export const getLocalizedStr = (multilangStr, prefLang, dataLangs, noFallback) => {

  if (multilangStr === null || multilangStr === undefined || multilangStr === {}) {
    return null
  }
  if (typeof (multilangStr) === "string") {
    return multilangStr
  }
  if (multilangStr[prefLang]) {
    return multilangStr[prefLang];
  }
  if (!noFallback) {
    for (let {code} of dataLangs) {
      if (multilangStr[code]) {
        return multilangStr[code];
      }
    }
    return multilangStr[Object.keys(multilangStr)[0]];
  } else {
    return "";
  }
};


// WEBPACK FOOTER //
// ./src/middlewares/i18n/utils.js